//线索库
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { get } from 'lodash';
import styles from './index.module.less';
import {
  SActionBtn,
  SLowcodeList,
  STableActions,
  SDrawerOrModal,
  SMessage,
} from 'shj-components'
import { config } from './config';
import {
  companyPrintVarTypeEnum,
  companyPrintVarConfig,
  updateCompanyPrintVarConfig,
  getCompanyPrintVarConfig,
  deleteCompanyPrintVarConfig
} from '@/services/goods';
import { getBranchComponyList } from '@/services/homeService';
import { Form, InputNumber, message, Popconfirm, Select, Input } from 'antd';

const { TextArea } = Input;

export default function SeatCommunicationCenter(props: any) {
  const [form] = Form.useForm();
  const listRef = useRef<any>();
  const [btnLoading, setBtnLoading] = useState(false); // 弹框确认按钮状态
  const [modalData, setModalData] = useState({}); //弹框数据
  const [visible, setVisible] = useState(false); // 弹窗是否显示
  const [companyList, setCompanyList] = useState([]);
  const [companyTypeList, setCompanyTypeList] = useState([]); // 字典类型下拉数据
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    getCompanyList();
  }, []);

  const getCompanyList = async () => {
    const companyRes: any = await getBranchComponyList();
    setCompanyList(companyRes);
    const typeRes: any = await companyPrintVarTypeEnum();
    setCompanyTypeList(typeRes);
  };

  // 简易弹窗
  const onEdit = (data: any) => {
    setVisible(true);
    setIsEdit(true);
    setModalData({ ...data });
    form.setFieldsValue(data);
  };

  const onAdd = () => {
    setVisible(true);
    setIsEdit(false);
  };

  const onDelete = async (id) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteCompanyPrintVarConfig(id);
          if (res.errorCode === 0) {
            message.success(res.message || '删除成功');
            (listRef as any)?.current?.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除');
      },
    });
  };
  // 弹框确定
  const modalOnOk = async () => {
      if (btnLoading) return;
      form.validateFields().then(async () => {
        try {
          let currentData = form.getFieldsValue();
          currentData = { ...modalData, ...currentData };
          setBtnLoading(true);
          if (isEdit) {
            const res: any = await updateCompanyPrintVarConfig(currentData)
            if (res?.id) {
              message.success(res.message || '编辑成功');
              listRef?.current?.reload();
              setVisible(false);
            }
          } else {
            const res: any = await companyPrintVarConfig(currentData)
            console.log(res)
            if (res?.id) {
              message.success(res.message || '新增成功');
              listRef?.current?.reload();
              setVisible(false);
            }
          }
          setBtnLoading(false);
        } catch (err) {
          setBtnLoading(false);
          console.log(err);
        }
      });
  };

  // 弹框取消
  const modalOnCancel = () => {
    setVisible(false);
    setModalData({});
    form.resetFields();
  };
  const fetchList = async (values: any) => {
      try {
        const { current = 1, pageSize = 10, query = {} } = values;
        const data = { ...query, orderBys: [
          {
            columnName: 'id',
            asc: false
          },
        ], companyId: query.companyId || '', searchFlag: true };
        
        const res: any = await getCompanyPrintVarConfig({ params: { pageId: current, pageSize }, data })
        if (res) {
          return { total: res.count, records: res.list };
        }
      } catch (e) {
        console.log(e);
      }

  };
  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      getBranchComponyList().then((res) => {
        return resolve({
          companyList: res,
        });
      });
    });
  };

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd },
    customRender: {
      operation(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn
              onClick={() => {
                onEdit(record);
              }}
            >
              编辑
            </SActionBtn>
            <SActionBtn 
              onClick={() => {
                onDelete(record.id);
              }}
              danger
            >
              删除
            </SActionBtn>
          </STableActions>
        );
      },
    },
  };

  return (
    <div>
      <SLowcodeList config={config} searchMode="group" ref={listRef} {...extension} />
      {visible ? <SDrawerOrModal
        mode="drawer"
        title={'变量配置'}
        open={visible}
        onOk={() => modalOnOk()}
        onCancel={() => modalOnCancel()}
        loading={btnLoading}
        width="500px"
      >
        <div className={styles.callQualifiedModal}>
          <Form labelCol={{ span: 12 }} form={form} initialValues={{}} layout="vertical">
            <Form.Item label="分公司" name="companyId" rules={[{ required: true, message: '请选择分公司' }]}>
              <Select>
                {companyList.map((item: any) => {
                  return (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item label="变量类型" name="varTypeCode" rules={[{ required: true, message: '请输入变量类型' }]}>
              <Select>
                {companyTypeList.map((item: any) => {
                  return (
                    <Select.Option key={item.key} value={item.key}>
                      {item.description}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item label="变量值" name="varValue" rules={[{ required: true, message: '请输入变量值' }]}>
              <Input style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="备注" name="remark">
              <TextArea style={{ width: '100%' }} />
            </Form.Item>
          </Form>
        </div>
      </SDrawerOrModal> : null }
    </div>
  );
}
